import React, {
  createContext,
  Dispatch,
  useContext,
  useReducer,
  useEffect,
} from "react";
import { DropDownOptions } from "../Models/Models";
import dayjs, { Dayjs } from "dayjs";
import { RecentActivities, RecentInsights } from "./WasteManagementContext";

export interface MasterDataContextType {
  activeTab: "AGRICULTURE" | "INFRASTRUCTURE" | "RETAIL" | "WASTE_MANAGEMENT";
  selectedItem: string;
  ifSideBarOpens: boolean;
  currentSideBarLocation: string;
  ifAddDeviceSelected: boolean;
  ifImpactAnalysisSelected: boolean;
  totalDevices: number; // new
  activeDevices: number; // new
  inactiveDevices: number;
  firstName: string;
  sidebaropen: boolean;
  siteOptions: DropDownOptions[];
  groupOptions: DropDownOptions[];
  isloading: boolean;
  binPlottingmapCenter: { lat: number; lng: number } | null;
  selectedSiteCode: string;
  selectedGroupCode: string;
  selectedDate: Dayjs | null;
  reportSelectedDate: Dayjs | null;
  recentActivities: RecentActivities[];
  recentInsights: RecentInsights[];
  recentInsightsselectedSiteCode: string;
}

const initialState: MasterDataContextType = {
  activeTab: "WASTE_MANAGEMENT",
  selectedItem: "Dashboard",
  ifSideBarOpens: false,
  currentSideBarLocation: "",
  ifAddDeviceSelected: true,
  ifImpactAnalysisSelected: true,
  totalDevices: 0,
  activeDevices: 0,
  inactiveDevices: 0,
  firstName: "",
  sidebaropen: true,
  isloading: false,
  binPlottingmapCenter: null,
  siteOptions: [],
  groupOptions: [],
  selectedSiteCode: "",
  selectedGroupCode: "",
  selectedDate: dayjs(),
  reportSelectedDate: null,
  recentActivities: [],
  recentInsights: [],
  recentInsightsselectedSiteCode:""
};

type ActionType = {
  type: "SET_FIELD";
  value:
    | string
    | boolean
    | number
    | DropDownOptions[]
    | { lat: number; lng: number }
    | dayjs.Dayjs
    | RecentActivities[]
    | RecentInsights[]
    | null;
  field: keyof MasterDataContextType;
};

const MasterDataProvider = createContext<{
  masterState: MasterDataContextType;
  dispatchMaster: Dispatch<ActionType>;
}>({
  masterState: initialState,
  dispatchMaster: () => null,
});

type ContextProviderProps = {
  children: React.ReactNode;
};

const reducer = (
  state: MasterDataContextType,
  action: ActionType
): MasterDataContextType => {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };
    default:
      return state;
  }
};

const MasterContext = ({ children }: ContextProviderProps) => {
  const [masterState, dispatchMaster] = useReducer(reducer, initialState);

  return (
    <MasterDataProvider.Provider value={{ masterState, dispatchMaster }}>
      {children}
    </MasterDataProvider.Provider>
  );
};

const useMasterData = () => {
  return useContext(MasterDataProvider);
};

export { MasterContext, useMasterData };
